<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <ul class="expensa-barlist">
    <li v-if="rows.length === 0" class="expensa-barlist-empty">
      {{ emptyText }}
    </li>
    <li v-for="row in rows" :key="row.key" class="expensa-barlist-row">
      <div class="expensa-barlist-head">
        <span class="expensa-barlist-label">{{ row.label }}</span>
        <span class="expensa-barlist-value">
          {{ row.amountText }} · {{ row.count }} {{ unit }}
        </span>
      </div>
      <div class="expensa-barlist-track" aria-hidden="true">
        <div
          v-if="row.width > 0"
          class="expensa-barlist-bar"
          :style="{width: row.width + '%'}"
        />
      </div>
    </li>
  </ul>
</template>

<script>
import {amountOf, barWidth} from '../util/dashboard';
import {eur} from '../util/format';

/**
 * Barre orizzontali in CSS. Ogni voce: {key, label, amount ("12.34"), count}.
 * Etichetta, importo e conteggio sono testo: la barra è solo un aiuto visivo.
 */
export default {
  name: 'ExpensaBarList',
  props: {
    items: {type: Array, default: () => []},
    unit: {type: String, default: ''},
    emptyText: {type: String, default: ''},
  },
  computed: {
    rows() {
      const max = this.items.reduce(
        (m, i) => Math.max(m, amountOf(i.amount)),
        0,
      );
      return this.items.map((i) => ({
        key: i.key,
        label: i.label,
        count: i.count,
        amountText: eur(i.amount),
        width: barWidth(amountOf(i.amount), max),
      }));
    },
  },
};
</script>

<style scoped lang="scss">
.expensa-barlist {
  list-style: none;
  margin: 0;
  padding: 0;
}
.expensa-barlist-empty {
  font-size: 0.8125rem;
  opacity: 0.75;
}
.expensa-barlist-row {
  margin-bottom: 0.6rem;
}
.expensa-barlist-head {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  font-size: 0.8125rem;
  margin-bottom: 0.2rem;
}
.expensa-barlist-label {
  overflow-wrap: anywhere;
}
.expensa-barlist-value {
  white-space: nowrap;
  font-weight: 700;
}
.expensa-barlist-track {
  height: 0.5rem;
  border-radius: 0.25rem;
  background: #e8eaef;
}
.expensa-barlist-bar {
  height: 100%;
  min-width: 2px;
  border-radius: 0.25rem;
  background: #76bc21;
}
</style>
